import { Directive, Input, OnInit, HostListener, Output, EventEmitter, ElementRef, Renderer2 } from '@angular/core';
import { SectionModule } from '../section/section.module';
import { SelectionModel } from '@angular/cdk/collections';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[paginationCheckbox]'
})
export class PaginationCheckboxDirective implements OnInit {

  private selection: SelectionModel<any>;
  private dataSourse: any[];
  private masterCheckboxHTML: HTMLElement;

  // datalist
  @Input() currentPageDataSource: any[];
  @Input() selectedItem: any;
  @Input() selectionFromComponent: SelectionModel<any>;
  @Input() checkboxMode = '';

  @Output() selectionChanges = new EventEmitter();
  @Output() checkMasterCheckbox = new EventEmitter();

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {
    const initialSelection = [];
    const allowMultiSelect = true;
    this.selection = new SelectionModel<any>(allowMultiSelect, initialSelection);
  }

  ngOnInit() {
    this.setDataSourse();
    this.updateSelection();
    this.getMasterCHeckboxElement();
    this.checkMasterCheckbox.emit(this.checkAllSelectedInPage());
  }

  private getMasterCHeckboxElement() {
    this.masterCheckboxHTML = document.getElementById('masterCheckBox');
    this.setIndeterminate(this.masterCheckboxHTML);
  }
  private setDataSourse() {
    if (Array.isArray(this.currentPageDataSource)) {
      this.dataSourse = this.currentPageDataSource;
    }
  }

  @HostListener('change') onClickMasterCkeckbox() {
    this.updateSelection();

    const masterCheckboxHTML: HTMLElement = document.getElementById('masterCheckBox');
    if (this.checkboxMode === 'master') {
      if (masterCheckboxHTML.getAttribute('indeterminate')) {
        this.setIndeterminate(masterCheckboxHTML);
        this.currentPageDataSource.forEach(
          (ele) => {
            if (this.isSelected(ele)) {
              this.selection.deselect(ele);
            }
          }
        );
      } else {
        this.currentPageDataSource.forEach(
          (item) => {
            this.selection.toggle(item);
          });
      }
    } else if (this.checkboxMode === 'specific' && this.selectedItem) {
      this.selection.toggle(this.selectedItem);
      this.setIndeterminate(masterCheckboxHTML);

      // this.renderer.setAttribute(masterCheckboxHTML, 'indeterminate', 'true');
    }
    this.checkMasterCheckbox.emit(this.checkAllSelectedInPage());
    this.selectionChanges.emit(this.selection);
  }

  private setIndeterminate(masterCheckboxHTML) {
    if (this.checkAllSelectedInPage()) {
      this.renderer.setAttribute(masterCheckboxHTML, 'indeterminate', 'false');
      this.renderer.setAttribute(masterCheckboxHTML, 'checked', 'true');
      masterCheckboxHTML.indeterminate = false;
      masterCheckboxHTML.checked = true;
      this.renderer.removeAttribute(masterCheckboxHTML, 'indeterminate');
    } else if ((this.selection.selected.length > 0 && (this.checkboxMode === 'specific'))) {
      masterCheckboxHTML.indeterminate = true;
      this.renderer.setAttribute(masterCheckboxHTML, 'indeterminate', 'true');
    } else {
      this.renderer.setAttribute(masterCheckboxHTML, 'indeterminate', 'false');
      this.renderer.setAttribute(masterCheckboxHTML, 'checked', 'false');
      masterCheckboxHTML.indeterminate = false;
      masterCheckboxHTML.checked = false;
      this.renderer.removeAttribute(masterCheckboxHTML, 'indeterminate');
      this.renderer.setAttribute(masterCheckboxHTML, 'checked', 'false');
    }
  }

  private updateSelection() {
    this.selection = this.selectionFromComponent;
  }

  private isSelected(item) {
    const isSelected = this.selection.isSelected(item);
    return isSelected;
  }

  private checkAllSelectedInPage(): boolean {
    if (this.currentPageDataSource.length > 0) {

      return this.currentPageDataSource.every(
        (ele) => {
          return this.isSelected(ele);
        });
    } else { return false; }
  }
}



// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/feature-modules/admin/directives/pagination-checkbox.directive.ts